import { Divider, VStack } from '@chakra-ui/react'
import { Checkbox } from '@missionlabs/react'
import { UserRole } from '@missionlabs/types'
import { useSettingsContext } from 'features/settings/components/settingsContext'
import { SettingsRow } from 'features/settings/components/SettingsRow'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUserRole } from 'shared/hooks/useUserRole'

interface Props {}

export const SettingsCallBarring: React.FC<Props> = () => {
    const { t } = useTranslation()
    const { user, onUpdateUser } = useSettingsContext()

    const isAdmin = useUserRole() === UserRole.ADMIN

    const handleCheckboxChange = (type: string, value: boolean) => {
        if (!user) return

        onUpdateUser({
            ID: user?.ID,
            outboundBarring: {
                all_calls: user?.outboundBarring?.all_calls ?? false,
                international_calling: user?.outboundBarring?.international_calling ?? false,
                premium_calling: user?.outboundBarring?.premium_calling ?? false,
                [type]: value
            }
        })
    }

    return (
        <>
            <SettingsRow label={t('admin.users.callBarring.callPermissions')}>
                <VStack width="full" spacing="16px" divider={<Divider />}>
                    <VStack align="left" width="full">
                        <Checkbox
                            isChecked={user?.outboundBarring?.international_calling ?? false}
                            isDisabled={!isAdmin}
                            onChange={e =>
                                handleCheckboxChange('international_calling', e.target.checked)
                            }
                        >
                            {t('admin.users.callBarring.international')}
                        </Checkbox>
                        <Checkbox
                            isChecked={user?.outboundBarring?.premium_calling ?? false}
                            isDisabled={!isAdmin}
                            onChange={e =>
                                handleCheckboxChange('premium_calling', e.target.checked)
                            }
                        >
                            {t('admin.users.callBarring.premium')}
                        </Checkbox>
                    </VStack>
                </VStack>
            </SettingsRow>
            <SettingsRow label={t('admin.users.callBarring.titleCallBarring')}>
                <VStack align="left" width="full">
                    <Checkbox
                        isChecked={user?.inboundBarring?.all_calls ?? true}
                        isDisabled={!isAdmin}
                        onChange={e =>
                            onUpdateUser({
                                ID: user?.ID,
                                inboundBarring: {
                                    ...user?.inboundBarring,
                                    all_calls: e.target.checked
                                }
                            })
                        }
                    >
                        {t('admin.users.callBarring.inboundCalls')}
                    </Checkbox>
                    <Checkbox
                        isChecked={user?.outboundBarring?.all_calls ?? true}
                        isDisabled={!isAdmin}
                        onChange={e => handleCheckboxChange('all_calls', e.target.checked)}
                    >
                        {t('admin.users.callBarring.outboundCalls')}
                    </Checkbox>
                </VStack>
            </SettingsRow>
        </>
    )
}
